import { AppDefId } from '../constants/constants';

export function getAccessTokenFunction() {
  const api = window.wixEmbedsAPI;
  if (api.getAccessTokenFunction) {
    const apiResult = api.getAccessTokenFunction();
    return apiResult;
  } else {
    return () => Promise.resolve(api.getAppToken(AppDefId));
  }
}
